/* Pure Care Detail — AJAX cart + mini-cart con venta cruzada */
(function () {
  if (window.PCDCart) return;
  var cfg = window.PCD || {};
  var products = cfg.products || [];
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  function money(cents) {
    var fmt = cfg.moneyFormat || '€{{amount_with_comma_separator}}';
    var v = (cents / 100).toFixed(2);
    var parts = v.split('.');
    var intDot = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    return fmt
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, intDot + ',' + parts[1])
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/, intDot)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, parts[0])
      .replace(/\{\{\s*amount\s*\}\}/, parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',') + '.' + parts[1]);
  }

  function esc(s) { var d = document.createElement('div'); d.textContent = s == null ? '' : String(s); return d.innerHTML; }

  var panel, overlay;
  function build() {
    if (panel) return;
    overlay = document.createElement('div');
    overlay.className = 'pcd-mc__overlay';
    overlay.addEventListener('click', close);
    panel = document.createElement('aside');
    panel.className = 'pcd pcd-mc';
    panel.setAttribute('role', 'dialog');
    panel.setAttribute('aria-modal', 'true');
    panel.setAttribute('aria-label', 'Carrito');
    panel.innerHTML =
      '<div class="pcd-mc__head"><strong class="pcd-mc__title">¡Añadido al carrito!</strong>' +
      '<button type="button" class="pcd-mc__x" aria-label="Cerrar">×</button></div>' +
      '<div class="pcd-mc__body"><ul class="pcd-mc__lines"></ul><div class="pcd-mc__up"></div></div>' +
      '<div class="pcd-mc__foot"><div class="pcd-mc__sub"><span>Subtotal</span><strong></strong></div>' +
      '<a class="pcd__btn pcd__btn--primary pcd__btn--block" href="' + root + 'checkout">Finalizar compra →</a>' +
      '<a class="pcd-mc__cart" href="' + root + 'cart">Ver carrito</a></div>';
    panel.querySelector('.pcd-mc__x').addEventListener('click', close);
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
    document.body.appendChild(overlay);
    document.body.appendChild(panel);
  }
  function open() { build(); requestAnimationFrame(function () { overlay.classList.add('is-open'); panel.classList.add('is-open'); }); }
  function close() { if (!panel) return; overlay.classList.remove('is-open'); panel.classList.remove('is-open'); }

  function render(cart) {
    build();
    var lines = panel.querySelector('.pcd-mc__lines');
    lines.innerHTML = cart.items.map(function (it) {
      var img = it.image ? it.image.replace(/(\.[a-z]+)(\?|$)/i, '_160x$1$2') : '';
      return '<li class="pcd-mc__line">' + (img ? '<img src="' + esc(img) + '" alt="" width="64" height="80" loading="lazy">' : '') +
        '<div><a href="' + esc(it.url) + '">' + esc(it.product_title) + '</a><span>' + it.quantity + ' × ' + money(it.final_price) + '</span></div>' +
        '<strong>' + money(it.final_line_price) + '</strong></li>';
    }).join('');
    panel.querySelector('.pcd-mc__sub strong').textContent = money(cart.total_price);
    var inCart = cart.items.map(function (i) { return i.product_id; });
    var ups = products.filter(function (p) { return p.available && inCart.indexOf(p.id) === -1; });
    var up = panel.querySelector('.pcd-mc__up');
    if (!ups.length) {
      up.innerHTML = '<p class="pcd-mc__done">✓ Tienes la rutina completa.</p>';
    } else {
      up.innerHTML = '<p class="pcd-mc__uptitle">Completa tu rutina</p>' + ups.map(function (p) {
        return '<div class="pcd-mc__upitem" style="--accent:' + esc(p.accent) + '">' +
          (p.image ? '<img src="' + esc(p.image) + '" alt="" width="56" height="70" loading="lazy">' : '') +
          '<div><span>' + esc(p.short) + '</span><small>' + money(p.price) + '</small></div>' +
          '<button type="button" class="pcd-mc__add" data-pcd-variant="' + p.variant + '">+ Añadir</button></div>';
      }).join('');
      up.querySelectorAll('[data-pcd-variant]').forEach(function (b) {
        b.addEventListener('click', function () {
          b.disabled = true; b.textContent = '…';
          add([{ id: +b.getAttribute('data-pcd-variant'), quantity: 1 }]).catch(function () { b.disabled = false; b.textContent = '+ Añadir'; });
        });
      });
    }
    var icon = document.querySelector('cart-icon');
    if (icon && typeof icon.renderCartBubble === 'function') { try { icon.renderCartBubble(cart.item_count); } catch (e) {} }
  }

  function add(items) {
    return fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (r) {
      return r.json().then(function (j) { if (!r.ok) throw new Error(j.description || j.message || 'Error'); return j; });
    }).then(function () {
      return fetch(root + 'cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); });
    }).then(function (cart) { render(cart); open(); return cart; })
      .catch(function (err) { toast(err.message || 'No se ha podido añadir'); throw err; });
  }

  function toast(msg) {
    var t = document.createElement('div'); t.className = 'pcd-toast'; t.textContent = msg;
    document.body.appendChild(t); setTimeout(function () { t.classList.add('is-in'); }, 10);
    setTimeout(function () { t.classList.remove('is-in'); setTimeout(function () { t.remove(); }, 300); }, 3500);
  }

  function withLoading(btn, p) {
    if (!btn) return p;
    var txt = btn.innerHTML; btn.disabled = true; btn.classList.add('is-loading');
    return p.finally(function () { btn.disabled = false; btn.classList.remove('is-loading'); btn.innerHTML = txt; });
  }

  document.addEventListener('submit', function (e) {
    var form = e.target.closest && e.target.closest('form[data-pcd-add]');
    if (!form) return;
    e.preventDefault();
    var id = +form.querySelector('[name="id"]').value;
    var q = form.querySelector('[name="quantity"]');
    var items = [{ id: id, quantity: Math.max(1, parseInt(q ? q.value : 1, 10) || 1) }];
    form.querySelectorAll('[data-pcd-extra]:checked').forEach(function (c) { items.push({ id: +c.value, quantity: 1 }); });
    var btn = e.submitter || form.querySelector('[type="submit"]');
    withLoading(btn, add(items)).catch(function () {});
  });

  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-pcd-add-all]');
    if (!b) return;
    e.preventDefault();
    var items = b.getAttribute('data-pcd-add-all').split(',').filter(Boolean).map(function (id) { return { id: +id, quantity: 1 }; });
    withLoading(b, add(items)).catch(function () {});
  });

  window.PCDCart = { add: add, open: open, close: close, money: money };
})();
